'use client'

import { XMarkIcon } from "@heroicons/react/24/outline"
import { useDemoContext } from './DemoContext'
import { useEffect } from 'react'

export function DemoModal() {
    const { selectedDemo, closeDemo } = useDemoContext()

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                closeDemo()
            }
        }

        if (selectedDemo) {
            document.addEventListener('keydown', handleKeyDown)
            return () => document.removeEventListener('keydown', handleKeyDown)
        }
    }, [selectedDemo, closeDemo])

    if (!selectedDemo) return null

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            closeDemo()
        }
    }

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            onClick={handleOverlayClick}
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
        >
            <div className="relative mx-4 w-full max-w-6xl rounded-lg bg-white p-6 shadow-lg dark:bg-zinc-900">
                <div className="mb-4 flex items-center justify-between">
                    <h2 id="modal-title" className="text-xl font-semibold dark:text-gray-100">
                        {selectedDemo.title} Demo
                    </h2>
                    <button
                        onClick={closeDemo}
                        className="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-zinc-800"
                        aria-label="Close modal"
                    >
                        <XMarkIcon className="h-6 w-6" />
                    </button>
                </div>
                <div className="relative w-full overflow-hidden rounded-md">
                    <iframe
                        src={selectedDemo.url}
                        loading="lazy"
                        title={`${selectedDemo.title} Demo`}
                        allow="clipboard-write"
                        className="h-[70vh] w-full"
                        frameBorder={0}
                        allowFullScreen
                    />
                </div>
            </div>
        </div>
    )
}